export const AbbreviateNumber = (value: any) => {
    if (value >= 100000) {
      return (value / 100000).toFixed(2) + "L";
    } else if (value >= 1000) {
      return (value / 1000).toFixed(2) + "k";
    }
    return value.toString();
  }